"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var upload_exports = {};
__export(upload_exports, {
  uploadError: () => uploadError,
  uploadMultipart: () => uploadMultipart,
  uploadXhr: () => uploadXhr
});
module.exports = __toCommonJS(upload_exports);
var import_core = require("@hcengineering/core");
async function uploadXhr(upload, options) {
  const signal = options?.signal;
  const onProgress = options?.onProgress;
  if (signal?.aborted === true) {
    throw new Error("Upload aborted");
  }
  const xhr = new XMLHttpRequest();
  const abortHandler = /* @__PURE__ */ __name(() => {
    xhr.abort();
  }, "abortHandler");
  if (signal !== void 0) {
    signal.addEventListener("abort", abortHandler);
  }
  try {
    return await new Promise((resolve, reject) => {
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          onProgress?.({
            loaded: event.loaded,
            total: event.total,
            percentage: Math.round(100 * event.loaded / event.total)
          });
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            status: xhr.status,
            responseText: xhr.responseText
          });
        } else {
          reject(uploadError(`Upload failed with status ${xhr.status}: ${xhr.statusText}`, xhr.status));
        }
      };
      xhr.onerror = () => {
        reject(uploadError("Network error", 0));
      };
      xhr.onabort = () => {
        reject(new Error("Upload aborted"));
      };
      xhr.ontimeout = () => {
        reject(uploadError("Upload timeout", 0));
      };
      xhr.open(upload.method, upload.url, true);
      if (upload.timeout !== void 0) {
        xhr.timeout = upload.timeout;
      }
      for (const key in upload.headers) {
        xhr.setRequestHeader(key, upload.headers[key]);
      }
      xhr.send(upload.body);
    });
  } finally {
    if (signal !== void 0) {
      signal.removeEventListener("abort", abortHandler);
    }
  }
}
__name(uploadXhr, "uploadXhr");
function uploadError(message, status) {
  return Object.assign(new Error(message), { status });
}
__name(uploadError, "uploadError");
const RETRY_PART_TIMEOUT = 10 * 60 * 1e3;
const RETRY_MAX_DELAY = 30 * 1e3;
const resumableUploads = /* @__PURE__ */ new Map();
async function uploadMultipart(upload, options) {
  const CHUNK_SIZE = upload.partSize ?? 5 * 1024 * 1024;
  const { url, headers, body, retryTimeout, resumeKey } = upload;
  const signal = options?.signal;
  const onProgress = options?.onProgress;
  const retry = /* @__PURE__ */ __name(async (op) => await withRetry(op, retryTimeout, signal), "retry");
  const resumed = resumeKey !== void 0 ? resumableUploads.get(resumeKey) : void 0;
  let uploadId = resumed?.uploadId;
  try {
    const parts = resumed?.parts ?? [];
    if (uploadId === void 0) {
      const created = await retry(
        async () => await multipartUploadCreate(url, { ...headers, "Content-Type": body.type }, signal)
      );
      uploadId = created.uploadId;
      if (resumeKey !== void 0) {
        resumableUploads.set(resumeKey, { uploadId, parts });
      }
    }
    const currentUploadId = uploadId;
    const totalParts = Math.ceil(body.size / CHUNK_SIZE);
    const sent = new Set(parts.map((it) => it.partNumber));
    let uploaded = 0;
    for (const partNumber of sent) {
      uploaded += Math.min(partNumber * CHUNK_SIZE, body.size) - (partNumber - 1) * CHUNK_SIZE;
    }
    for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
      if (sent.has(partNumber)) {
        continue;
      }
      const start = (partNumber - 1) * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, body.size);
      const chunk = body.slice(start, end);
      throwIfAborted(signal);
      const partOptions = {
        signal,
        onProgress: onProgress !== void 0 ? (progress) => {
          const loaded = uploaded + progress.loaded;
          onProgress({
            loaded,
            total: body.size,
            percentage: Math.round(loaded * 100 / body.size)
          });
        } : void 0
      };
      const { etag } = await retry(
        async () => await multipartUploadPart(
          url,
          headers,
          currentUploadId,
          partNumber,
          chunk,
          partOptions,
          retryTimeout !== void 0 ? RETRY_PART_TIMEOUT : void 0
        )
      );
      parts.push({ partNumber, etag });
      uploaded += chunk.size;
    }
    throwIfAborted(signal);
    parts.sort((a, b) => a.partNumber - b.partNumber);
    await retry(async () => {
      await multipartUploadComplete(url, headers, currentUploadId, parts, signal);
    });
    if (resumeKey !== void 0) {
      resumableUploads.delete(resumeKey);
    }
  } catch (err) {
    const resumable = resumeKey !== void 0 && signal?.aborted !== true && isRetryable(err);
    if (!resumable) {
      if (resumeKey !== void 0) {
        resumableUploads.delete(resumeKey);
      }
      if (uploadId !== void 0) {
        try {
          await multipartUploadAbort(url, headers, uploadId);
        } catch {
        }
      }
    }
    throw err instanceof Error ? err : new Error(String(err));
  }
}
__name(uploadMultipart, "uploadMultipart");
function throwIfAborted(signal) {
  if (signal?.aborted === true) {
    throw new Error("Upload aborted");
  }
}
__name(throwIfAborted, "throwIfAborted");
function isRetryable(err) {
  const status = err?.status;
  return status === void 0 || status === 0 || status === 408 || status === 429 || status >= 500;
}
__name(isRetryable, "isRetryable");
async function withRetry(op, timeout, signal) {
  const started = Date.now();
  for (let attempt = 0; ; attempt++) {
    try {
      return await op();
    } catch (err) {
      if (timeout === void 0 || signal?.aborted === true || !isRetryable(err) || Date.now() - started > timeout) {
        throw err;
      }
      const delay = Math.min(1e3 * 2 ** attempt, RETRY_MAX_DELAY);
      console.warn("upload request failed, retrying", { attempt: attempt + 1, delay, error: String(err) });
      await sleep(delay, signal);
    }
  }
}
__name(withRetry, "withRetry");
async function sleep(ms, signal) {
  await new Promise((resolve) => {
    const done = /* @__PURE__ */ __name(() => {
      clearTimeout(timer);
      signal?.removeEventListener("abort", done);
      resolve();
    }, "done");
    const timer = setTimeout(done, ms);
    signal?.addEventListener("abort", done);
  });
  throwIfAborted(signal);
}
__name(sleep, "sleep");
async function multipartUploadCreate(baseUrl, headers, signal) {
  const response = await fetch(baseUrl, {
    signal,
    method: "POST",
    headers
  });
  if (!response.ok) {
    throw uploadError("Failed to initialize multipart upload", response.status);
  }
  const { uuid, uploadId } = await response.json();
  return { uuid, uploadId };
}
__name(multipartUploadCreate, "multipartUploadCreate");
async function multipartUploadComplete(baseUrl, headers, uploadId, parts, signal) {
  const url = new URL((0, import_core.concatLink)(baseUrl, "/complete"));
  url.searchParams.set("uploadId", uploadId);
  const response = await fetch(url, {
    signal,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    body: JSON.stringify({ parts })
  });
  if (!response.ok) {
    throw uploadError("Failed to complete multipart upload", response.status);
  }
}
__name(multipartUploadComplete, "multipartUploadComplete");
async function multipartUploadPart(baseUrl, headers, uploadId, partNumber, blob, options, timeout) {
  const url = new URL((0, import_core.concatLink)(baseUrl, "/part"));
  url.searchParams.set("uploadId", uploadId);
  url.searchParams.set("partNumber", `${partNumber}`);
  const result = await uploadXhr(
    {
      url: url.toString(),
      method: "PUT",
      headers,
      body: blob,
      timeout
    },
    options
  );
  try {
    const response = JSON.parse(result.responseText);
    return { etag: response.etag };
  } catch (err) {
    throw new Error(`Failed to parse response for part ${partNumber}`);
  }
}
__name(multipartUploadPart, "multipartUploadPart");
async function multipartUploadAbort(baseUrl, headers, uploadId) {
  const url = new URL((0, import_core.concatLink)(baseUrl, "/abort"));
  url.searchParams.set("uploadId", uploadId);
  const response = await fetch(url, {
    method: "POST",
    headers
  });
  if (!response.ok) {
    throw new Error("Failed to reject multipart upload");
  }
}
__name(multipartUploadAbort, "multipartUploadAbort");
//# sourceMappingURL=upload.js.map
